var stat = 0;
var Sidebar = document.querySelector("#mySidebar");
var SidebarSecondNav = document.querySelectorAll(".MobileNav2");

function openNav() {
    Sidebar.classList.add("open");
    document.body.style.overflow = "hidden";
    setTimeout(function() {
        stat = 1;
    }, 100);
}

function closeNav() {
    Sidebar.classList.remove("open");
    document.body.style.overflow = "auto";
    SidebarSecondNav.forEach((nav) => {
        nav.classList.remove("open");
    });
    stat = 0;
}

function handleMousePos(event) {
    if (stat == 1) {
        const box = Sidebar;
        if (!box.contains(event.target)) {
            closeNav();
        }
    }
}

function initializeNestedAccordion() {
    const accordionItems = document.querySelectorAll(".nav_li_siderbar, .nav_li_siderbar2");
  
    accordionItems.forEach((item) => {
      const header = item.querySelector("span");
  
      if (header) {
        header.addEventListener("click", function () {
          const contentPanel = this.nextElementSibling;
  
          if (contentPanel && contentPanel.tagName === "UL") {
            this.classList.toggle("active");
  
            if (contentPanel.style.maxHeight) {
              // Collapse panel
              contentPanel.style.maxHeight = null;
              if(contentPanel.querySelector('.nav_li_siderbar2')){
                contentPanel.querySelectorAll('.nav_li_siderbar2').forEach((item) => {
                    item.querySelector("span").classList.remove("active");
                    item.querySelector("ul").style.maxHeight = null;
                });
              };
            } else {
              // Expand panel and set dynamic max-height
              contentPanel.style.maxHeight = contentPanel.scrollHeight + "px";
              if(contentPanel.parentElement.classList.contains("nav_li_siderbar2")){
                contentPanel.parentElement.parentElement.style.maxHeight = 
                (contentPanel.parentElement.parentElement.scrollHeight + contentPanel.scrollHeight) + "px";
              }
            }
          }
        });
      }
    });
  }
  
  // Initialize the accordion
  initializeNestedAccordion();
  
  
  


document.addEventListener("click", handleMousePos);